import React, { useContext } from 'react'
import RSRLMultipleBar from './RSRLMultipleBar'
import { useStaticQuery, graphql } from 'gatsby'

import { AccordionContext } from '../AccordionPage'

export default props => {
  const data = useStaticQuery(query)
  const edges = data.allRsrlSoinsPaliatifsXlsxPatients.edges
  const page = props.page
  const slug = useContext(AccordionContext)

  let labels = edges.map((row, i) => row.node.ANNEE)
  let patients = edges.map((row, i) => row.node.PATIENTS)
  let prestations = edges.map((row, i) => row.node.PRESTATIONS)

  let datasets = [
    {
      borderWidth: 0,
      stack: 'Patients',
      label: 'Patients suivis',
      data: patients,
      backgroundColor: '#d3adc7',
    },
    {
      borderWidth: 0,
      stack: 'Prestations',
      label: 'Prestations effectuées',
      data: prestations,
      backgroundColor: '#9b005b',
    },
  ]

  return (
    <div className="text-content">
      <div className="item-title">
        <h2 dangerouslySetInnerHTML={{ __html: page.acf.subtitle }} />
      </div>
      <div
        className="beforeCanvas"
        dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
      />
      <div
        className="beforeCanvas"
        dangerouslySetInnerHTML={{ __html: page.content }}
      />
      {/* <RSRLMultipleBar
        key={slug}
        labels={labels}
        datasets={datasets}
        // ylabel={'Nombre de personnes'}
        // xlabel={'Âge'}
      /> */}
    </div>
  )
}

const query = graphql`
  query {
    allRsrlSoinsPaliatifsXlsxPatients {
      edges {
        node {
          ANNEE
          PATIENTS
          PRESTATIONS
        }
      }
    }
  }
`
